import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgToggleCyclicIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	stroke: "currentColor",
	strokeLinecap: "round",
	strokeLinejoin: "round",
	strokeWidth: 2,
	viewBox: "0 0 24 24",
	...props,
	children: [/* @__PURE__ */ _jsx("path", { d: "M4 16c0-8 8-12 16-8" }), /* @__PURE__ */ _jsx("path", {
		strokeDasharray: "3 2",
		d: "M20 8c0 6-8 10-16 8"
	})]
});
export default SvgToggleCyclicIcon;
